module.exports = __webpack_public_path__ + "media/images/logos/brand-logo-app-transparent-brand-32x32-35b4a94407f6788bdc21db636acbfcf7.png";